module.exports = __webpack_public_path__ + "static/media/amusement(7).d5538e39.PNG";